import { ChevronRight, LucideIcon } from "lucide-react";
import { Button } from "../ui/button";
interface ProfileMenuItemProps {
  icon: LucideIcon;
  title: string;
  onPress: () => void;
  showBorder?: boolean;
}
export const ProfileMenuItem = ({ 
  icon: Icon, 
  title, 
  onPress, 
  showBorder = true 
}: ProfileMenuItemProps) => {
  return (
    <Button
      variant="ghost"
      className={`w-full h-auto p-4 flex items-center justify-between hover:bg-gray-50 rounded-none ${
        showBorder ? 'border-b border-gray-100' : ''
      }`}
      onClick={onPress}
    >
      <div className="flex items-center gap-4">
        <div className="w-6 h-6 flex items-center justify-center">
          <Icon className="w-5 h-5 text-gray-700" />
        </div>
        <span className="text-base font-medium text-black">{title}</span>
      </div>
      
      <ChevronRight className="w-5 h-5 text-gray-400" />
    </Button>
  );
};